"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { usePostHog } from "posthog-js/react";
import { Suspense, useEffect } from "react";
import { isBackendPath } from "@/shared/lib/backend-paths";

function Tracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();

  useEffect(() => {
    if (!pathname || !posthog || isBackendPath(pathname)) return;
    const search = searchParams.toString();
    posthog.capture("page_not_found", {
      pathname,
      search: search || undefined,
      referrer: document.referrer || undefined,
    });
  }, [pathname, searchParams, posthog]);

  return null;
}

export function NotFoundTracker() {
  return (
    <Suspense fallback={null}>
      <Tracker />
    </Suspense>
  );
}
